/**
 * Format number/string as phone number.
 * @param num
 */
export function toPhone(num?: number | string): string {
    if (!num && num !== 0) return "";
    num = num.toString();
    return `(${num.slice(0, 3)}) ${num.slice(3, 6)}-${num.slice(6, 10)}`;
}
